import { DispensaryCollectionsPage } from 'src/dispensary/collections';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getDispensaryServerSideProps;

export default Object.assign(DispensaryCollectionsPage, { layout: CoreMenuLayout });
